import React from 'react';
import { connect } from "react-redux";
import { identityCheck } from "../login/LoginActions";
import { bindActionCreators } from "redux";
import { getTestMessage } from "./AppActions";
// import Test2 from '../widget/components/test2';
import '../../assets/app.scss';
import Main from '../widget/components/Main';


function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

class App extends React.Component {

    state = {
        mobileOpen: false
    };

    componentWillMount() {
        const { identityCheck, history, routeChanged } = this.props;
        identityCheck();
        // history.listen((nextLocation, action) => {
        //     this.props.location.pathname !== nextLocation.pathname && routeChanged();
        // });
    }

    componentWillUpdate({ user }) {
        if (inIframe() && !user.fetching && !user.isLogin) {
            console.warn("isIframe", inIframe());
        } else {
            console.warn("isLogin", user.isLogin);
        }
    }

    componentDidUpdate = () => {
        const { setMainElement, app: { mainElement } } = this.props;
        if (!mainElement && this.mainElement) {
            setMainElement(this.mainElement);
        }
    };

    render() {
        // const {app, user, classes, handleSubmit, brand, location} = this.props;

        // if (!user.fetching && !user.isLogin) {
        //     return <button onClick={this.sendMessageToParent}>Authorize</button>
        // }

        return <Main />;
        // return <Test2 />;
    }
}

const mapStateToProps = ({ user, app, brand }) => ({ user, app, brand });

const mapDispatchToProps = dispatch => bindActionCreators({
    identityCheck,
    getTestMessage,
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(App);




// WEBPACK FOOTER //
// ./src/containers/app/App.js